// extracted by mini-css-extract-plugin
module.exports = {"galleryLink":"_ac40ba2f","locationText":"_a4efa187","icon":"_ae702c","locationIcon":"_dec4f491"};